import { HotelLocation } from "@/lib/redux/features/hotel/type"
import { Input, InputProps } from "antd"
import { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react"

type InputSearchProps = InputProps & {
  onSearch?: (searchValue?: string) => void,
  cardSize?: 'small' | 'default',
  valueObject?: any,
  value?: string,
}

export type InputSearchRef = {
  setSearchValue: (value: any) => void,
  getSearchValue: () => any,
}

const InputSearch = forwardRef<InputSearchRef, InputSearchProps>(({ onSearch, cardSize, valueObject, ...props }, ref) => {
  const [searchValue, setSearchValue] = useState<any>(props?.value || '')

  useEffect(() => {
    setSearchValue(props?.value)
  }, [props?.value])

  useImperativeHandle(ref, () => {
    return {
      setSearchValue: (value: any) => {
        setSearchValue(value)
      },
      getSearchValue: () => {
        return searchValue
      }
    }
  }, [searchValue])

  return (
    <Input
      {...props}
      value={searchValue}
      onClear={() => {}}
      onFocus={(e) => {}}
      onChange={(e) => {
        setSearchValue(e.target.value)
        if (onSearch) {
          onSearch(e.target.value)
        }
      }}
    />
  )
})

InputSearch.displayName = 'InputSearch'

export default memo(InputSearch)